const global = {
  state: {
    version: ''
  },

  mutations: {
    SET_VERSION: (state, version) => {
      state.version = version
    }
  },

  actions: {
    // 登录
    SetVersion({ commit }, version) {
      return new Promise(resolve => {
        commit('SET_VERSION', version)
        resolve()
      })
    }
  }
}

export default global